import "../Tweets.css";

//react
import { useEffect, useState } from "react";

//components
import TweetGraph from "../../reusable/TweetGraph/TweetGraph";

//antd
import { Typography } from "antd";

//hooks
import { useCurrentLanguage } from "../../../hooks/useCurrentLanguage";

//utils
import { getCsvData } from "../../../utils/functions/getCsvData";

//assets
import TEXT from "../../../utils/text/prensa.json";

//functionss
import { formatTrimesterLabel } from "../../../utils/functions/formatTrimesterLabel";

const { Title } = Typography;

export default function Gender({ 
    selectedCountry, 
    countryName, 
    countryOptions,
    setImg1, 
    setImg2,
    setImg3,
    setImg4,
    setImg5,
    setImg6,
    //setImg7
}) {
    //language
    const { language } = useCurrentLanguage();

    //useState - data2_t
    const [data2_t, setData2_t] = useState([]);

    //useState - data6
    const [data6, setData6] = useState([]);

    //useState - data Gen Sankey
    const [dataGenSankey, setDataGenSankey] = useState([]);

    //useState - img url 1
    // const [imgUrl1, setImgUrl1] = useState("");
    // const [imgUrl2, setImgUrl2] = useState("");
    // const [imgUrl3, setImgUrl3] = useState("");
    const [imgUrl4, setImgUrl4] = useState("");
    // const [imgUrl5, setImgUrl5] = useState("");
    // const [imgUrl6, setImgUrl6] = useState("");
    // const [imgUrl7, setImgUrl7] = useState("");

    //isLac
    const isLac = selectedCountry === 'LAC'

    //useEffect
    useEffect(() => {
        processData2T()
        processData6()
        processDataGenSankey("2023", 4)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCountry])

    //useEffect - imgs
    useEffect(() => {
        // setImg1(imgUrl1)
        // setImg2(imgUrl2)
        // setImg3(imgUrl3)
        setImg4(imgUrl4)
        // setImg5(imgUrl5)
        // setImg6(imgUrl6)
        //setImg7(imgUrl7)

        console.log(data2_t)
        console.log(dataGenSankey)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [imgUrl4])


    const processData2T = async () => {
        let df1 = await getCsvData(`/data/discussion/genero_3m.csv`);

        //filter country
        if (selectedCountry !== 'LAC') {
            df1 = df1.filter(row => row.country === selectedCountry);
        } else {
            let tempDf1 = {};
            df1.forEach((e) => {
                const date = formatTrimesterLabel(e.date);
                if (!tempDf1[date]) {
                    tempDf1[date] = {
                        date: e.date,
                        Genero: 0,
                        count: 0
                    };
                }
                tempDf1[date].Genero += parseFloat(e.Genero) || 0;
                tempDf1[date].count++;
            });

            df1 = Object.values(tempDf1).map(entry => ({
                date: entry.date,
                Genero: entry.Genero / entry.count
            }));
        }

        let dates = []
        let values = []

        df1.forEach((e) => {
            dates.push(formatTrimesterLabel(e.date, language))
            values.push(parseFloat(e.Genero))
        })

        let combinedArray = [dates, values]

        let temp = [
            {
                id: "q1",
                question: TEXT['topics']['graph1']['title'][language],
                data: combinedArray,
                rotate: false,
                graphType: "line",
                hasOptions: false,
                isPercentage: true,
                seriesName: language === 'es' ? ["Noticias"] : ["News"],
                updateTotrimester: false
            },
        ]

        setData2_t(temp)
    }

    const processData6 = async () => {
        let df1 = await getCsvData(`/data/discussion/gender_topics_3m.csv`);

        //filter country
        if (selectedCountry !== 'LAC') {
            df1 = df1.filter(row => row.country === selectedCountry);
        } else {
            let tempDf1 = {};
            df1.forEach((e) => {
                let date = formatTrimesterLabel(e.date);
                if (!tempDf1[date]) {
                    tempDf1[date] = {
                        date: e.date,
                        seguridad: 0,
                        servicios: 0,
                        empleo: 0,
                        politicas: 0,
                        transito: 0,
                        count: 0
                    };
                }
                tempDf1[date].seguridad += parseFloat(e.seguridad) || 0;
                tempDf1[date].servicios += parseFloat(e.servicios) || 0;
                tempDf1[date].empleo += parseFloat(e.empleo) || 0;
                tempDf1[date].politicas += parseFloat(e.politicas) || 0;
                tempDf1[date].transito += parseFloat(e.transito) || 0;
                tempDf1[date].count++;
            });

            df1 = Object.values(tempDf1).map(entry => ({
                date: entry.date,
                seguridad: entry.seguridad / entry.count,
                servicios: entry.servicios / entry.count,
                empleo: entry.empleo / entry.count,
                politicas: entry.politicas / entry.count,
                transito: entry.transito / entry.count
            }));
        }

        let dates = []
        let values = []
        let values2 = []
        let values3 = []
        let values4 = []
        let values5 = []

        df1.forEach((e) => {
            dates.push(formatTrimesterLabel(e.date, language))
            values.push(parseFloat(e.seguridad))
            values2.push(parseFloat(e.servicios))
            values3.push(parseFloat(e.empleo))
            values4.push(parseFloat(e.politicas))
            values5.push(parseFloat(e.transito))
        })

        let combinedArray = [dates, values, values2, values3, values4, values5]

        //calculate treemap data by getting the last value of each topic
        handleGenderTreemapChange(dates, values, values2, values3, values4, values5, values.length - 1, true)

        let temp = [
            {
                id: "q1",
                data: combinedArray,
                rotate: false,
                graphType: "line",
                hasOptions: false,
                isPercentage: true,
                seriesName: language === 'es' ? ["Seguridad", "Servicios", "Empleo", "Políticas", "Tránsito"] : ["Security", "Services", "Employment", "Policies", "Transit"],
                updateTotrimester: false,
                useColors: false,
                description: TEXT['indicadores']['gender1'][language]
            },
        ]

        setData6(temp)
    }

    const processDataGenSankey = async (selectedYear, selectedTrimester) => {
        let temp = await processSankey(selectedYear, selectedTrimester, `/data/discussion/sankey_gen_trim.csv`)
        setDataGenSankey(temp)
    }

    //process sankey data
    const processSankey = async (selectedYear, selectedTrimester, csvFile) => {
        let df = await getCsvData(csvFile);

        //setup period filters
        let years = []
        df.forEach((e) => {
            if(!years.includes(e.year)) years.push(e.year)
        })
        let yearOptions = []
        years.forEach((e) => {
            yearOptions.push({ code: e, label: e })
        })

        //let selectedYear = years[0]
        let trimesters = []
        df.forEach((e) => {
            if(!trimesters.includes(e.trimester) && e.year === selectedYear) trimesters.push(e.trimester)
        })

        let trimesterOptions = []
        trimesters.forEach((e) => {
            trimesterOptions.push({ code: `T${e}`, label: `T${e}` })
        })

        if(selectedTrimester === -1) selectedTrimester = parseInt(trimesters[trimesters.length - 1])

        //filter df by year and trimester
        df = df.filter(row => row.year === selectedYear && row.trimester === selectedTrimester.toString());
    
        let sourceIndex = 'source'
        let targetIndex = 'target'
        let valueIndex = 'value'
        let percentageIndex = 'percentage';

        let nodes = []
        let links = []

        df.forEach((e) => {
            if(!nodes.some(item => item.name === e[sourceIndex])) {
                nodes.push({ name: e[sourceIndex] })
            }

            if(!nodes.some(item => item.name === e[targetIndex])) {
                nodes.push({ name: e[targetIndex] })
            }
        })

        df.forEach((e) => {
            let tempLink = { source: e[sourceIndex], target: e[targetIndex], value: parseFloat(e[valueIndex]).toFixed(2)};
            if(e[percentageIndex]) {
                tempLink.percentage = parseFloat(e[percentageIndex]).toFixed(2);
            }
            links.push(tempLink);
        })

        let temp = [
            {
                id: "q1",
                data: nodes,
                links: links,
                years: yearOptions,
                trimesters: trimesterOptions,
                selectedYear: selectedYear,
                selectedTrimester: `T${selectedTrimester}`,
                rotate: false,
                graphType: "sankey",
                hasOptions: true,
                isPercentage: true
            },
        ]

        return temp
    }

    /* <--------------gender treemap functions-----------------> */
    const handleGenderTreemapChange = (dates, values, values2, values3, values4, values5, n, isGender) => {
        let treemapData = []
        treemapData.push({ name: language === 'es' ? "Seguridad" : "Security", code: "Seguridad", value: values[n] })
        treemapData.push({ name: language === 'es' ? "Servicios" : "Services", code: "Servicios", value: values2[n] })
        treemapData.push({ name: language === 'es' ? "Empleo" : "Employment", code: "Empleo", value: values3[n] })
        treemapData.push({ name: language === 'es' ? "Políticas" : "Policies", code: "Políticas", value: values4[n] })
        treemapData.push({ name: language === 'es' ? "Tránsito" : "Transit", code: "Tránsito", value: values5[n] })


        //based on dates (trimesters) create an object contaning the available years and trimesters for each year
        let years = []
        let trimesters = []

        dates.forEach((e) => {
            let year = e.split("-")[1]

            if(!years.includes(year)) {
                years.push(year)
            }
        })


        //sort dates
        const sortedDates = sortDateStrings(dates);

        //calculate year index based on n (index) of dates
        let yearIndex = sortedDates[n].split("-")[1]
        //get trimesters from last year
        sortedDates.forEach((e) => {
            let year = e.split("-")[1]
            if(year === yearIndex) {
                if(!trimesters.includes(e)) {
                    trimesters.push(e.split("-")[0])
                }
            }
        })

        //create year and trimester options (code, label)
        let yearOptions = []
        years.forEach((e) => {
            yearOptions.push({ code: e, label: e })
        })

        let trimesterOptions = []
        trimesters.forEach((e) => {
            trimesterOptions.push({ code: e, label: e })
        })

        //calculate trimester index based on n (index) of dates


        // let temp3 = [
        //         {
        //             id: "q1",
        //             data: treemapData,
        //             years: yearOptions,
        //             trimesters: trimesterOptions,
        //             selectedYear: yearIndex,
        //             selectedTrimester: trimesterIndex,
        //             rotate: false,
        //             graphType: "treemap",
        //             hasOptions: true,
        //             isPercentage: true,
        //             seriesName: language === 'es' ? ["Seguridad", "Servicios", "Empleo", "Políticas", "Tránsito", "Retorno"] : ["Security", "Services", "Employment", "Policies", "Transit", "Return"],
        //             updateTotrimester: false,
        //             useColors: false
        //         },
        // ]
    }

    function sortDateStrings(arr) {
        return arr.sort((a, b) => {
            // Extract the year and term/quarter number from each string
            const yearA = parseInt(a.slice(3));
            const yearB = parseInt(b.slice(3));
            const termQuarterA = parseInt(a.slice(1, 3));
            const termQuarterB = parseInt(b.slice(1, 3));

            // Compare the years
            if (yearA !== yearB) {
                return yearA - yearB;
            }

            // If the years are the same, compare the term/quarter numbers
            return termQuarterA - termQuarterB;
        });
    }

    // const handleYearChange = (value, key) => {
    //     if(key === 'gen') processDataGenSankey(value, -1)
    // }

    // const handleAllTrimesterChange = (year, value, key) => {
    //     if(key === 'gen') processDataGenSankey(year, parseInt(value.split("T")[1]))
    // }

    return (
        <div className={`surveys-page-content ${!isLac ? "prensa-small-section-container" : ""}`}>
            <div className="surveys-page-graphs">
                <div className="survey-page-full-surveys">
                    <div className={`full-screen ${isLac ? "prensa-chart-container sm:!gap-20" : ""}`}>
                        <div>
                            {data6.length > 0 && <TweetGraph data={data6} title={TEXT["vulnerable"]["graph_title"][language] + countryName} setImgUrl={setImgUrl4}/>}
                        </div>
                        <div className="prensa-chart-info-container pt-8">
                            {isLac && (
                                <>
                                    <div className={`data-page-section-title prensa-chart-title text-left ${isLac ? "" : "mb-6"}`}>
                                        {TEXT["vulnerable"][language]}
                                    </div>
                                    <Title level={2} style={{ color: "var(--blue-primary)", textAlign: "left" }}>
                                        {TEXT["vulnerable"]["title"][language]}
                                    </Title>
                                    <div className="prensa-text-container">
                                        <p>{TEXT["vulnerable"]["description"][language]}</p>
                                    </div>
                                </>
                            )}
                        </div>
                        {/* <div className="nl-selector-container">
                        </div> */}
                        <div>
                            {/* gender sankey */}
                            {/* {dataGenSankey.length > 0 && <TweetGraph data={dataGenSankey} title={TEXT['topics']['sankey_gen']['title'][language]} setImgUrl={setImgUrl5} onYearChange={(val) => handleYearChange(val, 'gen')} onTrimesterChange={(year, val) => handleAllTrimesterChange(year, val, 'gen')}/>} */}

                            {/* gender */}
                            {/* {data2_t.length > 0 && <TweetGraph data={data2_t} title={TEXT['topics']['gender']['title'][language] + " " + countryName} setImgUrl={setImgUrl3}/>} */}

                            {/* gender topics */}
                            {/* {data6.length > 0 && <TweetGraph data={data6} title={TEXT['topics']['topics_xeno']['title'][language] + ' ' + countryName} setImgUrl={setImgUrl4}/>} */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
  );
}
